module.exports = __webpack_public_path__ + "img/android@3x.43be76ed.png";